<mat-toolbar class="mat-elevation-z3 d-flex justify-content-between z-3 position-relative">
  <div class="d-flex align-items-center justify-content-center">
    <button mat-icon-button (click)="toggleSidebar()">
      <mat-icon>menu</mat-icon>
    </button>
    <img src="../../../assets/img/wi_move.png" width="140px" height="auto">
  </div>
  <div>
    <mat-menu #languageMenu="matMenu">
      <button mat-menu-item (click)="changeLanguage('en')">
        <span>English</span>
      </button>
      <button mat-menu-item (click)="changeLanguage('el')">
        <span>Ελληνικά</span>
      </button>
    </mat-menu>

    <button mat-icon-button [matMenuTriggerFor]="languageMenu">
      <mat-icon>language</mat-icon>
    </button>
    @if (environment.agrinio) {
    <!-- @if ((requests$ | async); as requests) { -->
    <button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="me-2">
      <mat-icon>notifications</mat-icon>
      <!-- <mat-badge [matBadge]="requests.length" matBadgeColor="warn" matBadgeOverlap="false"></mat-badge> -->
    </button>
    <mat-menu #notificationMenu="matMenu">
    </mat-menu>
    }
    <!-- } -->
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>account_circle</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <mat-icon>settings</mat-icon>
        <span>{{ 'ACCOUNT' | translate }}</span>
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>{{ 'LOGOUT' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>